export const chatInputMotionEase = [0.59, 0.15, 0.4, 0.78] as const;

export const chatInputMotionTransition = {
    duration: 0.3,
    ease: chatInputMotionEase,
};
